<template>
	<div v-if="!isHidden" id="showText">
		<div class="showTextWrapper">
			<div class="title">
				<h3>{{title + (stepIndex + 1)}}</h3>
			</div>

			<div class="contentWrapper">
				<div class="content left">

					<div class="element-top">
						<h3>Modell-Projektion</h3>

						<div v-if="step.model_slide" class="slide">

							<div>
								<img v-if="!isVideo(step.model_slide)"
									 v-bind:src="getImgUrl(step.model_slide)"/>
								<video v-else
									   v-bind:src="getVideoUrl(step.model_slide)"/>
								<p>{{step.model_slide.title}}</p>
							</div>

							<div class="text">
								<div v-html="step.model_slide.text"
									 class="slide-text"></div>
							</div>
						</div>
						<div v-else class="slide">
							<div class="placeholder">Kein Slide</div>
						</div>

						<div class="button-wrapper">
							<div v-if="step.model_slide && step.model_slide.text != ''"
								 class="button"
								 v-on:click="addText(step.model_slide.text)">
								<p>Einfügen</p>
							</div>
							<div v-else class="buttonDisabled">
								<p>Einfügen</p>
							</div>
						</div>

					</div>

					<hr/>

					<div class="element">
						<h3>Wand-Projektion</h3>

						<div v-if="step.wall_slide" class="slide">

							<div>
								<img v-if="!isVideo(step.wall_slide)"
									 v-bind:src="getImgUrl(step.wall_slide)"/>
								<video v-else
									   v-bind:src="getVideoUrl(step.wall_slide)"/>
								<p>{{step.wall_slide.title}}</p>
							</div>

							<div class="text">
								<div v-html="step.wall_slide.text"
									 class="slide-text"></div>
							</div>
						</div>

						<div v-else class="slide">
							<div class="placeholder">Kein Slide</div>
						</div>

						<div class="button-wrapper">
							<div v-if="step.wall_slide && step.wall_slide.text != ''"
								 class="button"
								 v-on:click="addText(step.wall_slide.text)">
								<p>Einfügen</p>
							</div>
							<div v-else class="buttonDisabled">
								<p>Einfügen</p>
							</div>
						</div>
					</div>
				</div>

				<div class="content right">
					<Notes v-bind:title.sync="step.title"
						   v-bind:text.sync="text"
						   v-bind:largeTextArea="true"/>
				</div>
			</div>

			<div class="controls">
				<div class="button" v-on:click="save">
					<p>Speichern</p>
				</div>

				<div class="button" v-on:click="closeTextEdit">
					<p>Abbrechen</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {EventBus} from '@/services/EventBus.js';
	import Step from '@/services/Step';
	import Notes from '@/components/layout/Notes.vue';

	export default {
		name: "ShowEditSlideText",
		components: {
			Notes
		},
		props: ['step', 'stepIndex', 'textShow'],
		watch: {
			textShow: function (newShowText) {
				if (this.step.id && newShowText) {
					this.showText();
				}
			}
		},
		methods: {
			isVideo(slide) {
				return slide.media.mime.includes('video');
			},
			getImgUrl(slide) {
				if (slide.media.formats && slide.media.formats.thumbnail) {
					return this.strapiUrl + slide.media.formats.thumbnail.url;
				} else {
					return this.strapiUrl + slide.media.url;
				}
			},
			getVideoUrl(slide) {
				return (this.strapiUrl + slide.media.url + '#t=5');
			},
			showText() {
				this.isHidden = false;
				this.text = (this.step.text) ? this.step.text : '';
			},
			closeTextEdit() {
				this.isHidden = true;
				this.$emit('hideText');
			},
			async save() {
				this.step.text = this.text;
				await Step.put(this.step);
				this.$emit('reloadText', this.step);
				this.closeTextEdit();
			},
			addText(text) {
				EventBus.$emit('onUpdateText', text);
			}
		},
		data() {
			return {
				isHidden: true,
				title: 'Notizen Step ',
				strapiUrl: process.env.VUE_APP_BASE_URL,
				text: ''
			}
		}
	}
</script>

<style scoped>
	#showText {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 99;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.showTextWrapper {
		background-color: white;
		width: 90%;
		height: 80%;
		position: relative;
	}

	.title {
		height: 73px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: solid 1px black;
	}

	.contentWrapper {
		display: flex;
		justify-content: space-around;
	}

	.content {
		width: 49%;
		height: 100%;
		padding: 5px;
	}

	input,
	textarea {
		width: 100%;
		margin-bottom: 20px;
	}

	.controls {
		width: 100%;
		display: flex;
		position: absolute;
		bottom: 0px;
		align-items: center;
		justify-content: center;
	}

	.button {
		width: 137px;
		padding: 3px 15px 3px 15px;
		margin-top: 10px;
	}

	.buttonDisabled {
		width: 137px;
		padding: 3px 15px 3px 15px;
		margin-top: 10px;
	}

	.placeholder {
		height: 90px;
		width: 160px;
		display: flex;
		border: 1px solid black;
		justify-content: center;
		padding-top: 32px;

	}

	img, video {
		height: 90px;
		width: 160px;
		/*display: flex;*/
	}

	.slide {
		display: flex;
		margin-top: 20px; /*41px;*/
	}

	.text {
		display: flex;
		flex-direction: column;
		margin-left: 15px;
		font-size: 16px;
	}

	.right {
		/*margin-top: 3%;*/
	}

	.left {
		padding-right: 20px;
		padding-left: 9%;
	}

	.element-top {
		margin-top: 20px; /*35px;*/
	}

	.button-wrapper {
		width: 100%;
		display: flex;
		justify-content: flex-end;
	}

	hr {
		margin-top: 20px;
		margin-bottom: 15px;
	}

	.slide-text {
		max-height: 90px; /*62px;*/
		overflow-y: auto;
	}

	#notes {
		width: 80%;
	}
</style>